import {createContext} from 'react';
import {AuthContextType, LoginType, SubscriptionTier} from "../utils/types";
import {useAuth} from "../utils/auth";

export const AuthContext = createContext<AuthContextType>({
  readAccessToken(): string | null { console.debug("Empty call"); return null; },
  storeAccessToken(access_token: string | null) { console.debug("Empty function"); },
  setCurrentUser(providedUser: string | null) { console.debug("Empty function"); },
  getCurrentUser(): string | null { console.debug("Empty call to get current user"); return null; },
  isAuthenticated(): boolean {console.debug("Not implemented"); return false;},
  getLoginType(): LoginType | undefined { console.debug("Empty login type"); return undefined; },
  storeLoginType(loginType: LoginType): void { console.debug("Empty login type"); },
  logout(): void { console.debug("Logging out empty function"); },
  getSubscriptionTier(): SubscriptionTier{ console.debug("Empty get subscription tier function"); return SubscriptionTier.free},
});


export const AuthProvider: React.FC<{children: React.ReactElement}> = ({children})=> {
  let {
    readAccessToken,
    storeAccessToken,
    setCurrentUser,
    getCurrentUser,
    isAuthenticated,
    getLoginType,
    storeLoginType,
    logout,
    getSubscriptionTier
  } = useAuth();

  return (
    <AuthContext.Provider value={{
      readAccessToken,
      storeAccessToken,
      setCurrentUser,
      getCurrentUser,
      isAuthenticated,
      getLoginType,
      storeLoginType,
      logout,
      getSubscriptionTier
    } as AuthContextType}>
      {children}
    </AuthContext.Provider>
  )

}
